export function dateToApiString(d: Date) {
    return `${d.getFullYear()}-${d.getMonth() + 1 < 10 ? '0' : ''}${d.getMonth() + 1}-${
        d.getDate() < 10 ? '0' : ''
    }${d.getDate()}`
}

export function dateTimeToApiString(d: Date) {
    return `${dateToApiString(d)} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
}
